// auto-generated by build process
/**
 * @constant {string} VERSION Flex version
 * @private
 */
export const VERSION = "2.18.0";
